import { InMemoryCache } from '@apollo/client';
import { offsetLimitPagination } from '@apollo/client/utilities';
import vMessageTemplateVar from './components/SMS/VMessagesCache';

// Extracted from index.tsx so tests can build a cache with the app's real type
// policies instead of a hand-rolled stand-in that could drift from production
// (see src/components/Hub/Messages/hubMessageCache.test.ts).
export function createApolloCache(): InMemoryCache {
  return new InMemoryCache({
    typePolicies: {
      PetParent: {
        keyFields: ['id', 'careType', 'animalType'],
      },
      TicketReview: {
        keyFields: ['tagName'],
      },
      Query: {
        fields: {
          petParents: {
            ...offsetLimitPagination(['awoId', 'onboardingStatus', 'order', 'orderBy', 'smsStatus', 'interests']),
            read(existing, { args }) {
              const { offset, limit } = args as any;
              return existing && existing.slice(offset, offset + limit);
            },
          },
          newsfeed: {
            ...offsetLimitPagination(),
            merge(existing = [], incoming = []) {
              return [...existing, ...incoming];
            },
          },
          hubMessageTimeline: {
            // Two queries read this single un-normalized object: the full timeline
            // (Messages page) and a lightweight unreadCount (nav badge / Home banner,
            // fetched on every Hub page). They share one cache slot, so without a
            // merge whichever resolves last wins — the partial unreadCount write would
            // drop `messages`/`membershipStatus` and blank the page. Shallow-merge so
            // a partial write only updates the fields it carries.
            merge(existing, incoming) {
              return { ...existing, ...incoming };
            },
          },
          tasks: {
            keyArgs(args) {
              if (args?.startDaysAgo === -1) {
                return ['completed', 'startDaysAgo', 'endDaysAgo', 'careType', 'species'];
              }
              return ['completed', 'careType', 'species'];
            },
            merge(existing = [], incoming = []) {
              const ids = new Set<any[]>([]);
              const mergedArrays = [] as any[];
              const mergeFn = (e: any) => {
                // eslint-disable-next-line dot-notation,no-underscore-dangle
                if (!ids.has(e.__ref)) {
                  // eslint-disable-next-line dot-notation,no-underscore-dangle
                  ids.add(e.__ref);
                  mergedArrays.push(e);
                }
              };
              existing.forEach(mergeFn);
              incoming.forEach(mergeFn);
              return mergedArrays;
            },
          },
        },
      },
      Campaign: {
        fields: {
          vMessageTemplate: {
            read() {
              return vMessageTemplateVar();
            },
          },
        },
      },
    },
  });
}

export default createApolloCache;
